<template>
  <div class="checkout__button_cover">
    <button
      class="checkout__button"
      :disabled="totalItems === 0"
      @click="goToCheckout"
    >
      Checkout
    </button>
  </div>
</template>
<script>
import {
  onMounted, useContext, useRouter, computed,
} from '@nuxtjs/composition-api';
import useCart from '~/modules/checkout/composables/useCart';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import { useExternalCheckout } from '~/composables';

export default {
  name: 'CheckoutButton',
  setup() {
    const { localePath } = useContext();
    const router = useRouter();
    const { load, cart } = useCart();
    const { initializeCheckout } = useExternalCheckout();
    const goToCheckout = async () => {
      const redirectUrl = initializeCheckout({ baseUrl: '/checkout/user-account' });
      await router.push(localePath(redirectUrl));
    };
    onMounted(async () => {
      await load();
    });
    const totalItems = computed(() => cartGetters.getTotalItems(cart.value));
    return {
      goToCheckout,
      totalItems,
    };
  },
};

</script>
<style scoped>
.checkout__button{
  background-color: var(--c-primary);
  color: var(--color-white);
  border-radius: 3px;
  border: none;
  transition: all .3s ease;
  cursor: pointer;
  margin-left: 20px;
  &:hover {
    background-color: var(--c-primary-variant-second);
  }
}
</style>
